///<reference path="student.module.ts" />
///<reference path="student.context.ts" />
///<reference path="../../components/baseClasses/dataMaintenanceControllerBase.ts"/>
///<reference path="../../components/common/common.interface.ts"/>
///<reference path="../../components/baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../components/modal/modal.interface.ts"/>
///<reference path="../../components/common/security.service.ts"/>
///<reference path="../../components/logging/logging.interface.ts"/>
///<reference path="../../components/tracking/tracking.interface.ts"/>
///<reference path="../../main/contextParams.service.ts"/>
///<reference path="../../components/busy/busy.interface.ts"/>
///<reference path="../../components/common/common.imageGalleryService.ts"/>
///<reference path="../../components/models/meevo.model.custom.ts"/>

module Meevo.Plugins.Student {
    import StudentContext = Meevo.Plugins.Student.StudentContext;

    interface IStudentsSearchCriteria {
        showEmployeesOnly: boolean;
        showTerminated: boolean;
        EmployeeEntityTypeEnum: Meevo.Model.EmployeeEntityTypeEnum;
    }

    class StudentController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public canLocationAddUser: number = 1;
        public searchCriteria: IStudentsSearchCriteria;

        // statically inject constructor resources
        static $inject = [
            'meevo.AppSettings',
            '$http',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            '$filter',
            'meevo.components.common.ImageGalleryService',
            'meevo.components.common.RatingsService',
            '$translate',
            "$timeout"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected $http: angular.IHttpService,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $filter: angular.IFilterService,
                    protected imageGalleryService: Meevo.Components.Common.IImageGalleryService,
                    protected ratingsService: Meevo.Components.Common.IRatingsService,
                    protected $translate: ng.translate.ITranslateService,
                    protected $timeout: ng.ITimeoutService        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService, {
                use: true,
                appAreaEnum: Meevo.Model.AppAreaEnum.Employee
            });

            this.searchCriteria = {
                showEmployeesOnly: true,
                showTerminated: false,
                EmployeeEntityTypeEnum: Meevo.Model.EmployeeEntityTypeEnum.Student
            };

            this.dataService.customMethodData('api/Employee/CanLocationAddMoreUser', 'GET', '', {
                locationId: this.identityService.locationId,
                excludeUserId: '00000000-0000-0000-0000-000000000000'
            }).then(result => {
                this.canLocationAddUser = result.data;
            });
        }

        public createContext(): void {
            let vm = <StudentController>this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_STUDENT)
                .then(() => {
                    vm.busyService.stop();
                    vm.context = new StudentContext(this.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$rootScope, vm.busyService, vm.customDataContextConfig, vm.imageGalleryService, vm.ratingsService, this.$timeout, null, this.$translate, this.canLocationAddUser);
                    super.createContext();
                    vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
                    vm.context.deactivate = () => {
                        vm.visualState = Model.MaintenanceFormVisualState.Search;
                    };
                })
                .catch(() => {
                    vm.busyService.stop();
                });
        }


    }

    angular.module('meevo.plugins.student')
        .controller('meevo.plugins.student.StudentController', StudentController);
}
